module.exports = __webpack_public_path__ + "static/media/liaa-eraf-banner-en.05ec82bc.svg";